import React, { useEffect } from 'react';
import Text from 'components/atoms/Text';
import Spinner from 'components/atoms/Spinner';
import { useGetAlloc8SyncStatsQuery } from 'redux/api/vehicleIncidents';
export interface IDashboardAlloc8SyncWidget {
	getUpdatedTime?: () => string;
}

const DashboardAlloc8SyncWidget: React.FC<IDashboardAlloc8SyncWidget> = ({
	getUpdatedTime,
}) => {
	const { data, isLoading, error } = useGetAlloc8SyncStatsQuery();

	useEffect(() => {
		if (data && getUpdatedTime) {
			getUpdatedTime();
		}
	}, [data, getUpdatedTime]);
	if (isLoading) {
		return (
			<div className="relative">
				<div className="space-y-3">
					<div className="flex justify-center items-center py-4">
						<Spinner />
					</div>
				</div>
			</div>
		);
	}
	if (error) {
		return (
			<div className="relative">
				<div className="space-y-3">
					<div className="flex justify-center items-center py-4">
						<Text className="text-red-600">Error loading data</Text>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="relative">
			<div className="space-y-3 mb-4">
				{data && (
					<>
						<div className="flex justify-between items-center mt-4">
							<Text className="text-[30px] text-[#333] font-bold">
								{data.totalIncidents}
							</Text>
							<Text className="text-[13px] font-semibold text-[#000] bg-gray-200 px-2 py-0 rounded">
								Total incidents
							</Text>
						</div>

						<div className="text-[14px] text-gray-600 pt-[2px] pb-4">
							Incidents synchronized from Alloc8 today
						</div>

						<div className="flex justify-between items-center bg-[#EBF6EE]  px-3 py-3 rounded border border-green-300 ">
							<Text className="text-[16px] text-[#737373] flex items-center">
								<p className="pl-1">New:</p>
							</Text>
							<Text className="text-[20px] font-bold text-green-600">
								{data.newIncidents}
							</Text>
						</div>

						<div className="flex justify-between items-center bg-[#E8F0FD] px-3 py-3 rounded border border-blue-300">
							<Text className="text-[16px] text-[#737373]">Open:</Text>
							<Text className="text-[20px] font-bold text-blue-600">
								{data.openIncidents}
							</Text>
						</div>
						<div className="flex justify-between items-center bg-[#FDEDED] px-3 py-3 rounded border border-red-400">
							<Text className="text-[16px] text-[#737373] flex items-center">
								Duplicate:
							</Text>
							<Text className="text-[20px] font-bold text-orange-600">
								{data.duplicateIncidents}
							</Text>
						</div>
						<div className="flex justify-between items-center bg-[#F9F2FD] px-3 py-3 rounded border border-purple-300">
							<Text className="text-[16px] text-[#737373]">Nuisance:</Text>
							<Text className="text-[20px] font-bold text-purple-600">
								{data.nuisanceIncidents}
							</Text>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default DashboardAlloc8SyncWidget;
